import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import type { ForwardRefForwardPropsComponent } from '../../types';

import List from './List';
import type { ListProps } from './List';

const OrderedList: ForwardRefForwardPropsComponent<ListProps> = forwardRef(function OrderedList(
  props: PropsWithoutRef<ListProps>,
  ref: ListProps['ref']
) {
  return <List {...props} variant='ordered' ref={ref} />;
});

export default OrderedList;
